import type { AxiosError, AxiosInstance } from 'axios';
import axios from 'axios';

import config from '@/utils/config';
import { useAuthStore } from '@/store/auth.store.ts';
import { handleAxiosError } from '@/utils/lib/api/error.helper.ts';
import { addController } from '@/utils/lib/api/controller.ts';

export function createAxiosInstance(baseURL: string): AxiosInstance {
  const instance = axios.create({ baseURL });

  instance.interceptors.request.use((config) => {
    const authToken = useAuthStore.getState().authToken;

    if (authToken) {
      config.headers['Authorization'] = `Bearer ${authToken}`;
    }

    const controller = new AbortController();
    config.signal = controller.signal; // attach signal
    addController(controller);

    return config;
  });

  instance.interceptors.response.use(
    (res) => res,
    (error: AxiosError) => Promise.reject(handleAxiosError(error)),
  );

  return instance;
}

// Base API instance
const axiosInstance = createAxiosInstance(
  `${config.apiURL}/${config.apiVersion}/`,
);
export default axiosInstance;
